import React from 'react';
import {bem} from '../../utils/bem';
import Button from './Button';

const block = bem('links');

const Links = ({links = []}) => (<ul className={block()}>
		{links.map((link) => (
			<li className={block('item')} key={link.label}>
				<Button label={link.label} onClick={link.onClick} href={link.href} active={link.active}/>
			</li>
		))}
	</ul>
);

export default Links;
